// Styles
import CRNTNavContainer from "./CRNTNav.styles";
import ReportsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ReportsTab/ReportsTab";
import AlertsTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/AlertsTab/AlertsTab";
import ChangeLogTab from "../../../../components/Screens/DailyRecs/DailyFlowsCheck/ChangeLogTab/ChangeLogTab";
import Tabs from "../../../../components/Common/Tabs/Tabs";

interface CRNTNavProps {}

const checkName = "cr_nt_nav";

const CRNTNav = ({}: CRNTNavProps) => {
    return (
        <CRNTNavContainer>
            <p className={"sectionTitle"}>CR VS NT NAV</p>
            <Tabs
                defaultTab="reports"
                tabs={[
                    {
                        value: "reports",
                        title: "REPORTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ReportsTab reportId="ca126861-b17c-4dd0-911b-80494050cd65" workspaceId="a42e71f1-8daa-48e5-a1d6-ad5674016128" />,
                    },
                    {
                        value: "alerts",
                        title: "ALERTS",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <AlertsTab checkName={checkName} />,
                    },
                    {
                        value: "change_log",
                        title: "CHANGE LOG",
                        permissions: ["p_can_view_navs", "p_can_action_navs"],
                        content: <ChangeLogTab checkName={checkName} />,
                    },
                ]}
            />
        </CRNTNavContainer>
    );
};

export default CRNTNav;
